import { useDeleteItem } from '@api/generics';
import API_ROUTES from '@api/routes';
import { ItemDeleteDialog } from '@components/DataGrid';
import React from 'react';
import { IPermission } from 'types/authorization';
import { IRowActionDialogProps } from 'types/common';

const PermissionDeleteDialog: React.FC<IRowActionDialogProps> = ({
	onComplete,
	row
}) => {
	const { id } = row!.row;
	const deleteMutation = useDeleteItem<IPermission>(
		id,
		'permissions',
		API_ROUTES.v1.permissions.delete(id)
	);

	return (
		<ItemDeleteDialog
			onComplete={onComplete}
			row={row}
			questionLabelId="permissions.action.delete.dialog.question"
			titleLabelId="permissions.action.delete.dialog.header"
			toastLabelPrefix="permissions.action.delete.dialog.toast"
			deleteMutation={deleteMutation.mutateAsync}
		/>
	);
};

export default PermissionDeleteDialog;
